/* global G */
import { curry } from 'lib/util'
import status from 'model/request/collection/status'

/**
 * @param {Gaia.AppModule.Spec} module - app module
 * @param {Gaia.Component.Spec} component - action component
 * @param {Gaia.PlatformEvent|string} eventOrKey
 * @returns {Array} countries
 */
const listRequestStatus = (module, component, eventOrKey) => {
  const key = eventOrKey?.detail?.key || eventOrKey
  const scope = key ? status.filter(item => item.key === key) : status

  return scope.map(item => ({
    ...item,
    value: module[G.ADAPTER][G.INTL]._t(
      `status.request.${item.key}`,
      {
        ns: 'ticket',
        _key: `status.request.${item.key}`,
        defaultValue: item.value,
      },
    ),
  }))
}

export default curry(listRequestStatus)
